import styled from 'styled-components'

const MyDiv = styled.div`
.table_header {
    background-color: #f9fafb !important;
  }
 .empId {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    cursor: pointer;
    white-space: nowrap; 
  }
.action{
text-decoration: underline;
color: rgba(0, 122, 255, 1);

align-items: center;
cursor: pointer;
}
.view{
  text-decoration: underline;
  color: #006838;
  cursor: pointer;
  }
`
export default MyDiv